import { Company } from '@employ-engage/data';
import Modal from '../modal/modal';
import AddCompanyForm from '../add-company-form/add-company-form';
import { useTranslation } from 'react-i18next';

export interface AddCompanyModalProps {
  isSuperAdminPanel?: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  companySelectedForEditing?: Company | null;
  setCompanySelectedForEditing: (company: Company | null) => void;
  refetchCompaniesUserBelongsTo?: () => void;
  isFirstTimeSetup?: boolean;
}

export function AddCompanyModal({
  isSuperAdminPanel,
  open,
  setOpen,
  companySelectedForEditing,
  setCompanySelectedForEditing,
  refetchCompaniesUserBelongsTo,
  isFirstTimeSetup,
}: AddCompanyModalProps) {
  const { t } = useTranslation(['common']);
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      panelClassName="max-w-[800px]"
      disableCloseOnOutsideClick={isFirstTimeSetup}
    >
      <div>
        <div className="text-2xl font-bold leading-9 text-gray-900">
          {t('Add Company')}
        </div>
      </div>
      <div className="mt-5">
        <AddCompanyForm
          isFirstTimeSetup={isFirstTimeSetup}
          isSuperAdminPanel={isSuperAdminPanel}
          setOpen={setOpen}
          companySelectedForEditing={companySelectedForEditing}
          setCompanySelectedForEditing={setCompanySelectedForEditing}
          refetchCompaniesUserBelongsTo={refetchCompaniesUserBelongsTo}
        />
      </div>
    </Modal>
  );
}

export default AddCompanyModal;
